import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

// Получить сигналы с сортировкой
export const apiGetSignalsSorted = async (sortKey, direction = 'desc', nextUrl = null) => {
  let url;
  
  if (nextUrl) {
    // Если передан URL следующей страницы, используем его
    url = nextUrl;
  } else {
    // Иначе создаем новый URL с параметрами сортировки
    url = `${backendUrl}/api/signals/?sort_${sortKey}=${direction}`;
  }

  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };

  try {
    const response = await fetchWithAuth(url, options);

    if (!response.ok) {
      throw new Error(
        `Ошибка сети при получении отсортированных сигналов: ${response.status}`
      );
    }

    return await response.json();
  } catch (error) {
    console.error('Ошибка API сортировки сигналов:', error);
    throw error;
  }
};